import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';

import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatDividerModule } from '@angular/material/divider';
import { MatListModule } from '@angular/material/list';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatDialogModule } from '@angular/material/dialog';

import {
  BannerComponent,
  NavigationComponent,
  HelpMenuComponent,
  NavigationTriggerDirective,
} from '@presencelearning/ui';
import { PlCommonModule } from '@app/common/common.module';
import { PlHeaderComponent } from './pl-header/pl-header.component';
import { PlSecureLayoutComponent } from './pl-secure-layout/pl-secure-layout.component';
import { PlAccountDropdownComponent } from './pl-account-dropdown/pl-account-dropdown.component';
import { CurrentLicenseComponent } from './current-license/current-license.component';

@NgModule({
  declarations: [
    PlHeaderComponent,
    PlSecureLayoutComponent,
    PlAccountDropdownComponent,
    CurrentLicenseComponent,
  ],
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    MatChipsModule,
    MatMenuModule,
    MatToolbarModule,
    MatDividerModule,
    MatListModule,
    MatInputModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatDialogModule,
    MatDatepickerModule,
    ReactiveFormsModule,
    RouterModule,
    PlCommonModule,
    BannerComponent,
    NavigationComponent,
    HelpMenuComponent,
    NavigationTriggerDirective,
  ],
  exports: [
    PlAccountDropdownComponent,
    PlHeaderComponent,
    PlSecureLayoutComponent,
  ],
})
export class LayoutModule {}
